export default __webpack_public_path__ + "static/media/maya-4.98e8029e.jpg";